import {
  Component,
  HostListener,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { DatatableConfig } from "src/app/config/DatatableConfig";
import {
  IInstanciasResponse,
  IEscuela,
  IGetAsignaturasResponse,
  IPeriodo,
  IPeriodosResponse,
  IAlineacion,
  IBodyAlineacion,
  IAlineacionesResponse,
  IAsignatura,
} from "src/app/interfaces/integracion-blackboard";
import { IntegracionesBlackboardService } from "src/app/services/integraciones-blackboard/integraciones-blackboard.service";
import { IntegracionSharedService } from "../integracion-shared.service";

interface IParam {
  currPage: number;
  pageSize: number;
  search: string;
}
@Component({
  selector: "app-integracion-blackboard-inicio",
  templateUrl: "./view-integracion-blackboard-inicio.component.html",
  styleUrls: ["./view-integracion-blackboard-inicio.component.scss"],
})
export class ViewIntegracionBlackboardInicioComponent implements OnInit {
  integracionForm: {
    instanciaId: number;
    escuelaId: number;
    siglaAsignatura: number;
    filtroPeriodos: string[];
  } = {
    instanciaId: -1,
    escuelaId: -1,
    siglaAsignatura: -1,
    filtroPeriodos: [],
  };
  filtrosSeleccionados: {
    instanciaId: number;
    escuelaId: number;
    siglaAsignatura: number;
    filtroPeriodos: string[];
  } = {
    instanciaId: -1,
    escuelaId: -1,
    siglaAsignatura: -1,
    filtroPeriodos: [],
  };
  renderTableIntegraciones = false;
  dtOptions: DataTables.Settings = { ...DatatableConfig.dtOptionsWithPopOver };

  dropdownOpen: boolean = false; // Controls the dropdown visibility

  listaIntegraciones: Array<IAlineacion> = [];
  periodos: Array<IPeriodo> = [];
  indexAccionSeleccionado: number = -1;
  instancias: Array<IInstanciasResponse> = [];
  escuelas: Array<IEscuela> = [];

  alertaExitosa: string[] = [];
  alertaError = "";
  alertaExitosaDeshabilitado: string[] = [];

  //sigla asignatura

  filtroAsignaturas: IGetAsignaturasResponse = {} as IGetAsignaturasResponse;
  loadingSigla: boolean = false;
  periodoPaginacion = {
    pagSize: 10,
    currPage: 1,
    totalPages: 1,
    totalItems: 0,
  };
  siglaAsignaturaPaginacion = {
    pageSize: 20,
    currPage: 1,
    totalPages: 1,
    totalItems: 0,
  };
  tmpSigla: {
    SiglaPaginacion: {
      pageSize: number;
      currPage: number;
      totalPages: number;
      totalItems: number;
    };
    listado: {
      sigla: string;
      siglaIdSap: string;
      descripcion: string;
      idSap: string;
    }[];
  } = {
    SiglaPaginacion: {
      pageSize: 20,
      currPage: 1,
      totalPages: 1,
      totalItems: 0,
    },
    listado: [],
  };
  searchValueSigla: string = "";
  filtroSigla: string | undefined = undefined;

  //fin sigla asignatura

  constructor(
    private readonly router: Router,
    private readonly _integracionService: IntegracionesBlackboardService,
    
    public readonly _integracionSharedService: IntegracionSharedService
  ) {
    const routerData =
      this.router.getCurrentNavigation()?.extras?.state?.["data"];
    if (routerData?.integracionCreada) {
      this.alertaExitosa[0] =
        "La alineación entre asignaturas del Portal de Calificaciones y Blackboard, se ha guardado correctamente.";
      this.alertaExitosa[1] =
        "Si se realiza un cambio en Blackboard, las calificaciones integradas con Portal de Calificaciones no se actualizarán automáticamente.";
      this.alertaExitosa[2] =
        "Deberá realizar el proceso de integración nuevamente.";
    }
    if (routerData?.integracionError) {
      this.alertaError =
        "Ha ocurrido un error inesperado y no se han podido integrar las calificaciones. Por favor intente nuevamente.";
    }
  }

  ngOnInit() {
    const arrowElement = document.querySelector(".mat-mdc-select-arrow");
    if (arrowElement) {
      arrowElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" class="select-icon" stroke="black" stroke-width="1.5" class="bi bi-chevron-down custom-icon" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
</svg>`;
    }

    this.getInstancias();
    this.getPeriodos();

    this.dtOptions = { ...DatatableConfig.dtOptionDefaultSearchRight };
    this.dtOptions = {
      ...this.dtOptions,
      columnDefs: [
        {
          width: "auto",
          type: "date",
          targets: [6],
          render: function (data: string, type: string) {
            // Si es el tipo de renderizado para ordenamiento o display
            if (data === null || data === undefined || data === "") return "";
            let date = data
              .split('class="celda"')[1]
              .replace("</p>", "")
              .replace(">", "");
            if (type === "sort" || type === "type") {
              return moment(date, "DD-MM-YYYY"); // Devuelve el valor original para ordenamiento
            }
            return moment(date, "DD-MM-YYYY").format("DD-MM-YYYY"); // Formatea la fecha para mostrarla
          },
        },
      ],
      order: [[6, "desc"]],
    };

    setTimeout(() => {
      this.renderTableIntegraciones = true;
    }, 500);
  }
  getInstancias() {
    this._integracionService.getInstancias().subscribe({
      next: (res: IInstanciasResponse[]) => {
        this.instancias = res;
      },
    });
  }
  getPeriodos(pageNumber: string = "1", pageSize: string = "1000") {
    this._integracionService.getPeriodos(pageNumber, pageSize).subscribe({
      next: (res: IPeriodosResponse) => {
        this.periodos = res.listado;
        this.periodoPaginacion.currPage = res.currentPage;
        this.periodoPaginacion.totalPages = res.totalPages;
        this.periodoPaginacion.totalItems = res.totalItems;
      },
    });
  }
  getEscuelas() {
    this.escuelas = [];
    this.integracionForm.escuelaId = -1;
    this._integracionService
      .getEscuelas(String(this.integracionForm.instanciaId))
      .subscribe({
        next: (res) => {
          this.escuelas = res.listado;
        },
      });
  }
  getAlineamientos() {
    this.alertaExitosa = [];
    this.alertaError = "";
    this.renderTableIntegraciones = false;
    let periodosSeleccionados: Array<string> = [];
    this.periodos.forEach((periodo) => {
      if (this.integracionForm.filtroPeriodos.includes(periodo.siglaPeriodo)) {
        periodosSeleccionados.push(
          `${periodo.anoAcademico}-${periodo.periodoAcademicoId}`
        );
      }
    });
    let body: IBodyAlineacion = {
      instanciaId: this.integracionForm.instanciaId,
      programaId: this.integracionForm.escuelaId,
      asignaturaId:
        this.integracionForm.siglaAsignatura !== -1
          ? this.integracionForm.siglaAsignatura
          : undefined,
      listaPeriodos:
        periodosSeleccionados.length !== 0 ? periodosSeleccionados : undefined,
    };
    if (body.asignaturaId === undefined) delete body.asignaturaId;
    if (body.listaPeriodos === undefined) delete body.listaPeriodos;
    this._integracionService.getAlineaciones(body).subscribe({
      next: (res: IAlineacionesResponse) => {
        this.listaIntegraciones = res.listado;
        this.renderTableIntegraciones = true;
        this.filtrosSeleccionados = { ...this.integracionForm };
      },
    });
  }

  //filtro asignatura

  

  onSearchSigla(term: {term: string, items: Array<IAsignatura>}): void {
    this.searchValueSigla = term.term;

    if (term.term.length >= 3) {
      let reqParams: IParam = {
        currPage: 1,
        pageSize: 20,
        search: term.term.toUpperCase(),
      };

      this._integracionSharedService.getAsignaturas(this,reqParams);
    }
    if (
      (term.term.length > 3 || term.items.length === 0) &&
      this.filtroAsignaturas?.listado?.length <
        this.siglaAsignaturaPaginacion.totalItems
    ) {
      if (this.tmpSigla.listado.length === 0) {
        this.tmpSigla = {
          SiglaPaginacion: this.siglaAsignaturaPaginacion,
          listado: this.filtroAsignaturas.listado,
        };
      }
      // buscar en servicio
      let reqParams: IParam = {
        currPage: 1,
        pageSize: 20,
        search: term.term.toUpperCase(),
      };

      this._integracionSharedService.getAsignaturas(this,reqParams);
    }
  }
  changeSiglaAsignatura(evento: IAsignatura) {
    if (evento) {
      this.integracionForm.siglaAsignatura = evento.asignaturaId;
    } else {
      this.integracionForm.siglaAsignatura = -1;
    }
  }

  //fin filtro asignatura

  busqueda() {
    if (this.validarCampos()) {
      this.getAlineamientos();
    }
  }
  validarCampos(): boolean {
    if (
      this.integracionForm.instanciaId === -1 ||
      this.integracionForm.escuelaId === -1
    ) {
      return false;
    }
    return true;
  }
  limpiarFiltros() {
    this.integracionForm = {
      instanciaId: -1,
      escuelaId: -1,
      siglaAsignatura: -1,
      filtroPeriodos: [],
    };
    this.filtroSigla = undefined;
    this.escuelas = [];
    this.renderTableIntegraciones = false;
    this.listaIntegraciones = [];
    this.alertaExitosaDeshabilitado = [];
    this.alertaExitosa = [];
    this.alertaError = "";
    setTimeout(() => {
      this.renderTableIntegraciones = true;
    }, 20);
  }
  crearIntegracion() {
    this.router.navigate(["/crear-integracion"]);
  }
  deshabilitarIntegracion() {
    document.getElementById("modal-deshabilitar")?.click();
  }
  deleteIntegracion() {
    this.alertaExitosaDeshabilitado = [];
    const integracionSeleccionada =
      this.listaIntegraciones[this.indexAccionSeleccionado];

    this._integracionService
      .deshabilitarAlineacion(String(integracionSeleccionada.alineacionId))
      .subscribe({
        next: () => {
          this.integracionForm = this.filtrosSeleccionados;
          this.alertaExitosaDeshabilitado[0] =
            integracionSeleccionada.siglaAsignatura;
          this.alertaExitosaDeshabilitado[1] =
            integracionSeleccionada.siglaPeriodo;
          this.getAlineamientos();
        },
      });
    this.indexAccionSeleccionado = -1;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  //popOver functions
  togglePopover(index: number) {
    if (index === this.indexAccionSeleccionado) {
      this.indexAccionSeleccionado = -1;
    } else {
      this.indexAccionSeleccionado = index;
    }
  }
  @HostListener("document:click", ["$event"])
  cerrarClickFuera(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest(".btn") && !target.closest(".cstm-popover")) {
      this.indexAccionSeleccionado = -1;
    }
  }
}
